const fetchAllContent = async () => {
  try {
    const [covers, courses, sections, topbar, globals, creators, products] = await Promise.all([
          fetch(`${import.meta.env.VITE_DIRECTUS_PUBLIC_URL}/items/cover_text_translations`),
          fetch(`${import.meta.env.VITE_DIRECTUS_PUBLIC_URL}/items/Course?fields=course_cover_image,course_calendly_embed,course_translations.*&filter[status][_eq]=published`),
          fetch(`${import.meta.env.VITE_DIRECTUS_PUBLIC_URL}/items/page_section?fields=section_name,section_cover,translations.*`),
          fetch(`${import.meta.env.VITE_DIRECTUS_PUBLIC_URL}/items/top_bar?fields=*,translations.*`),
          fetch(`${import.meta.env.VITE_DIRECTUS_PUBLIC_URL}/items/Globals?fields=*`),
          fetch(`${import.meta.env.VITE_DIRECTUS_PUBLIC_URL}/items/creator?fields=*,creator_translations.*&filter[status][_eq]=published`),
          fetch(`${import.meta.env.VITE_DIRECTUS_PUBLIC_URL}/items/Products?fields=id,status,product_name,product_price,product_image,product_shop_url,creator_id&filter[status][_eq]=published`)
    ]);
    const content = {
      covers: await covers.json(),
      courses: await courses.json(),
      sections: await sections.json(),
      topbar: await topbar.json(),
      globals: await globals.json(),
      creators: await creators.json(),
      products: await products.json()
    };
    return content;
  } catch (error) {
    console.error("Content fetch error:", error);
    throw error;
  }
};

const nestedSplitter = (data, translation_key, non_translatable_keys = []) => {
  const data_con = data
    .map((item) => {
      return item[translation_key].map((subitem) => {
        const nonTranslatableFields = {};
        non_translatable_keys.forEach(key => {
          nonTranslatableFields[key] = item[key];
        });
        return { ...nonTranslatableFields, ...subitem };
      });
    }).flat();

  const { "it-IT": data_it = [], "en-US": data_en = [] } = Object.groupBy(
    data_con,(item) => item.languages_code);
  return [ data_it, data_en ]
};

const parseDirectus = (directusContent) => {
  //covers
  const covers = directusContent.covers.data.filter(item => item.cover_text_id );
  const { "it-IT": cover_it = [], "en-US": cover_en = [] } = Object.groupBy(
    covers,
    (item) => item.languages_code,
  );
  //courses
  const [ courses_it, courses_en ] = nestedSplitter(directusContent.courses.data, "course_translations", ["course_cover_image","course_calendly_embed"]);
  //sections
  const [ sections_it, sections_en ] = nestedSplitter(directusContent.sections.data,"translations",["section_cover","section_name"])
  // Top bar
  const [ topbar_it, topbar_en ] = nestedSplitter(directusContent.topbar.data,"translations",["status","color"])
  //creators
  const [ creators_it, creators_en ] = nestedSplitter(directusContent.creators.data, "creator_translations", ["creator_name","creator_url","creator_image","creator_logo","creator_ig"])
  //products (non-translated, but need separate copies for each language)
  const productsFiltered = directusContent.products.data.filter(product => product.status === "published");
  const products_it = [...productsFiltered];
  const products_en = [...productsFiltered];
  //Globals
  const globals = directusContent.globals.data;
  //json for i18n
  const parsedContent = {
    it: {
      cover_text: cover_it,
      course_data: courses_it,
      sections_data: sections_it,
      topbar: topbar_it,
      creators_data: creators_it,
      products_data: products_it
    },
    en: {
      cover_text: cover_en,
      course_data: courses_en,
      sections_data: sections_en,
      topbar: topbar_en,
      creators_data: creators_en,
      products_data: products_en
    },
  };
  return parsedContent;

  //courses
};

export const fetchAndParse = async () => {
  const directusContent = await fetchAllContent();
  const parsedContent = parseDirectus(directusContent);
  const topbarStatus = {
        status: directusContent.topbar.data[0]?.status,
        color: directusContent.topbar.data[0]?.color
      };
  const directusGlobals = {
    calendly_general_url: directusContent.globals.data.calendly_general_url,
    contact_whatsapp_number: directusContent.globals.data.contact_whatsapp_number,
    contact_email: directusContent.globals.data.contact_email,
    favicon_logo: directusContent.globals.data.favicon_logo
  }

  return {
    parsedContent,
    topbarStatus,
    directusGlobals,
  };
};
